export enum EXPORT_HISTORY_STATE {
  EXPORTING = 1,
  COMPLETE = 2,
  FAILED = 3,
}

export enum EXPORT_HISTORY_TYPE {
  FEEDBACK = 1,
  INSIGHT = 2,
  TAXONOMY = 3,
}

export const EXPORT_HISTORY_TYPE_MAP = {
  [EXPORT_HISTORY_TYPE.FEEDBACK]: 'Feedback',
  [EXPORT_HISTORY_TYPE.INSIGHT]: 'Insight',
  [EXPORT_HISTORY_TYPE.TAXONOMY]: 'Taxonomy',
};
